import React from "react";
import * as R from "ramda";
import CSSModules from "react-css-modules";
import css from "./styles.scss";
import { Div, Text4 } from "components/Base";
import { getAccentColor } from "../PortalHome/selectors";
import { connect } from "react-redux";

const decorate = R.compose(
  connect(state => ({
    accentColor: getAccentColor(state)
  })),
  CSSModules(css)
);

const Panel = ({
  title = "",
  children = null,
  length = null,
  panelContainerStyle = {},
  icon = null,
  onClickHeader,
  accentColor
}) => (
  <Div className={css.panel}>
    <Div
      display="row.flex-start.center"
      className={css.borderBottomContainer}
      flex={1}
      px={5}
      py={4}
      onClick={onClickHeader}
      style={{
        backgroundColor: accentColor ? accentColor : undefined
      }}
    >
      {icon && (
        <i
          className={`material-icons-outlined ${icon}`}
          style={{
            fontSize: "18px",
            marginRight: "6px",
            color: "white"
          }}
        >
          {icon}
        </i>
      )}
      <Text4 fw={3} color="white">
        {`${title} ${!R.isNil(length) && length !== 0 ? `(${length})` : ""}`}
      </Text4>
    </Div>
    <Div px={4} pb={5} pt={4} style={panelContainerStyle}>
      {children}
    </Div>
  </Div>
);

export default decorate(Panel);
